module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1236.6c6aefa0.png";